import { HttpErrorCodes, HttpRequestError } from '../utils/http/HttpErrors';
import { ResultJSON } from '../Common/BridgeInterface';

export const AccountConfigErrorStrings = {
	ROAMING_ACCOUNTS_FETCH_FAILURE: 'Roaming accounts request failed',
	INVALID_ROAMING_ACCOUNTS_URL: 'Invalid roaming accounts URL',
	DISCOVERY_FETCH_FAILURE: 'Discovery request failed',
	ENDPOINT_FETCH_FAILURE: 'Endpoint request failed',
	REFRESH_FLOW_FAILURE: 'Refresh flow failed',
	ROAMING_ACCOUNTS_SEND_FAILURE: 'Roaming accounts send failure',
	APPCONFIG_SERVICE_PAYLOAD_EXPIRED: 'Payload expired',
	REFRESH_FLOW_TRIGGERED_FOR_ON_PREM: 'Refresh flow triggered for on prem store',
	DISCOVER_PROBE_FETCH_FAILURE: 'Discover probe fetch failure',
	INDEX_PROBE_FETCH_FAILURE: 'Index probe fetch failure',
	CGI_AUTH_FETCH_FAILURE: 'Cgi authenticate fetch failure',
	REDIRECT_FETCH_FAILURE: 'Redirect fetch failure',
	UNEXPECTED_COOKIE_VALUE: 'Unexpected cookie value',
	VPN_INDEX_PROBE_FETCH_FAILURE: 'Index probe returned unexpected status code',
	SHOULD_ADDACCOUNT_PROCEED_CANCEL: 'ShouldAddAccountProceed returned status as false',
	REFRESH_FAILED_GATEWAY_SESSION_EXPIRED:
		'Refresh failed since user is logged out, and interactive mode is false',
};

export const ParserErrorStrings = {
	DISCOVERY_DOC_RESPONSE_PARSE_ERROR: 'Error parsing discovery document',
	ENDPOINT_RESPONSE_PARSE_ERROR: 'Error parsing endpoints response',
	ROAMING_ACCOUNTS_PARSE_ERROR: 'Error parsing roaming accounts response',
	ONPREM_ROAMING_ACCOUNTS_PARSE_ERROR_ACCOUNTS_NOT_PRESENT:
		'Error parsing on-prem roaming response - account nodes are not present',
	ONPREM_ROAMING_ACCOUNTS_PARSE_ERROR: 'Error parsing on-prem roaming accounts response',
	REDIRECT_RESPONSE_PARSE_ERROR:
		'Error parsing redirect response - no location header present',
	SELF_DECLARED_AUTH_TYPE_PARSE_ERROR:
		'Error parsing self declared auth type from reponse headers',
};

export const AddAccountErrors = {
	INVALID_ACCOUNT_URL: 'Invalid account URL',
	HTTP_STORE_NOT_SUPPORTED: 'HTTP Stores not supported',
	HTTP_STORE_NOT_ALLOWED: 'HTTP Stores not allowed',
	ACCOUNT_EXISTS_ON_NATIVE: 'Account exists on native',
	START_CLOUD_FLOW_ERROR: 'start cloud flow failed',
	TIME_OUT_ERROR: 'Timed out while adding account',
	INVALID_SCHEMA: 'Invalid schema',
	ACCOUNT_EXISTS: 'Account exists',
	AUTH_CANCELLED_BY_USER: 'Auth cancelled by user',
	EMAIL_DISCOVERY_FAILURE: 'Email discovery failure',
	NO_ACCOUNT_AVAILABLE: 'No account available',
	REQUESTED_ACCOUNT_NOT_AVAILABLE: 'Requested account not available',
	UNKNOWN_ERROR: 'Unknown error',
	CERTIFICATION_FAILURE: 'Certification failure',
	URL_IS_NOT_REACHABLE: 'Url is not reachable',
	STORE_ALREADY_EXISTS: 'Store already exists',
	STORE_URL_SUCCESS: 'Store url success',
	REQUESTED_ACCOUNT_ALREADY_EXISTS: 'Requested account already exists',
	URL_INVALID: 'Url invalid',
	SHOW_CERT_WARNING: 'Show cert warning',
	PROTOCOL_ERROR: 'Protocol error',
	UNEXPECTED_ERROR: 'Unexpected error',
	NOT_IMPLEMENTED: 'Not implemented',
	UNSUPPORTED_CALL_SEQUENCE: 'Unsupported call sequence',
	GATEWAY_NOT_SUPPORTED: 'Gateway not supported',
	CERTIFICATE_FREE_FAILED: 'Certificate free failed',
	ALREADY_PROCESSING: 'Already processing',
	SYSTEM_ERROR: 'System error',
	NETWORK_ERROR: 'Network error',
	CERTIFICATE_ERROR: 'Certificate error',
	INTERACTION_NOT_ALLOWED: 'Interaction not allowed',
	LOGON_NOT_ALLOWED: 'Logon not allowed',
	NO_SUITABLE_LOGON_PROTOCOL: 'No suitable logon protocol',
	DISALLOWED_BY_SECURITY_POLICY: 'Disallowed by security policy',
	AUTH_SERVER_ERROR: 'Auth server error',
	REPORTED_RESPONSE_UNRECOGNIZED: 'Reported response unrecognized',
	VPN_NOT_POSSIBLE: 'Vpn not possible',
	OUT_OF_LICENSES: 'Out of licences',
	SECURE_BROWSE_NOT_SUPPORTED: 'Secure browse not supported',
	INVALID_PNA_TOKEN_COUNT: 'Invalid pna token count',
	SERVER_CERTIFICATE_NOT_TRUSTED: 'Server certificate not trusted',
	GET_USER_PASS_FROM_SSON: 'Get user pass from sson',
	HTTP_REQUEST_FAILED: 'Http request failed',
	HTTP_CANNOT_CONNECT: 'Http cannot connect',
	HTTP_NAME_NOT_RESOLVED: 'Http name not resolved',
	MISSING_SERVER_CERTIFICATE: 'Missing server certificate',
	MULTIPLE_CONFIG_STORES_FOUND: 'Multiple config stores found',
	CONFIGURATION_REQUEST_MISSING: 'Configuration request missing',
	PUBLIC_CERTIFICATECHAIN_ERROR: 'Public certification chain validation error',
	DISCOVERED_ACCOUNT_EXIST: 'Discovered account exist',
	DISCOVERED_STORE_EXIST: 'Discovered store exist',
	SUCCESS: 'Success',
	END_POINT_FETCH_FAILURE: 'End point fetch failure',
	ERROR_RETRIEVING_ROAMING_ACCOUNTS_RESPONSE:
		'Error while retrieving roaming account response for existing session',
	SECONDARY_STORE_ADDITION_NOT_ALLOWED: 'Secondary store addition not allowed',
	MULTIPLE_GACS_DISCOVERED_STORES_WITH_SINGLE_ALLOWED:
		'Multiple GACS discovered stores with single allowed',
	SINGLE_GACS_HYBRID_STORE_ALREADY_EXISTS: 'Single GACS hybrid store already exists',
};

//Before adding a new error code make sure they are in sync with the codes in the native code
export const AccountConfigErrorCode = {
	REFRESH_FLOW_ERROR: 100,
	LEGACY_FLOW_ERROR: 101,
	CLOUD_FLOW_ERROR: 102,
	GET_ACCOUNTS_ERROR: 103,
	TRUST_ACCOUNT_ERROR: 104,
	CUSTOM_PORTAL_FLOW_ERROR: 105,
	ONPREM_FLOW_ERROR: 106,
	GATEWAY_FLOW_ERROR: 107,
	GENERAL_ERROR: 108,
	ADD_ACCOUNT_WITHOUT_UI_ERROR: 109,
	PERFORM_GACS_DISCOVERY_ERROR: 110,
	GET_ALL_GACS_HYBRID_STORES_INFO_ERROR: 111,
};

export enum ErrorStatusCodes {
	SUCCESS = 0,
	INVALIDSCHEMA,
	ACCOUNTEXISTS,
	AUTHCANCELLEDBYUSER,
	EMAILDISCOVERYFAILURE,
	NOACCOUNTAVAILABLE,
	REQUESTEDACCOUNTNOTAVAILABLE,
	UNKNOWNERROR,
	CERTIFICATIONFAILURE,
	URLISNOTREACHABLE,
	STOREALREADYEXISTS,
	STOREURLSUCCESS,
	REQUESTEDACCOUNTALREADYEXISTS,
	URLINVALID,
	SHOWCERTWARNING,
	PROTOCOLERROR,
	UNEXPECTEDERROR,
	NOTIMPLEMENTED,
	UNSUPPORTEDCALLSEQUENCE,
	GATEWAYNOTSUPPORTED,
	CERTIFICATEFREEFAILED,
	ALREADYPROCESSING,
	SYSTEMERROR,
	NETWORKERROR,
	CERTIFICATEERROR,
	INTERACTIONNOTALLOWED,
	LOGONNOTALLOWED,
	NOSUITABLELOGONPROTOCOL,
	DISALLOWEDBYSECURITYPOLICY,
	AUTHSERVERERROR,
	REPORTEDRESPONSEUNRECOGNIZED,
	VPNNOTPOSSIBLE,
	OUTOFLICENSES,
	SECUREBROWSENOTSUPPORTED,
	INVALIDPNATOKENCOUNT,
	SERVERCERTIFICATENOTTRUSTED,
	GETUSERPASSFROMSSON,
	HTTPREQUESTFAILED,
	HTTPCANNOTCONNECT,
	HTTPNAMENOTRESOLVED,
	MISSINGSERVERCERTIFICATE,
	MULTIPLECONFIGSTORESFOUND,
	CONFIGURATIONREQUESTMISSING,
	PUBLICCERTIFICATECHAINERROR,
	SECONDARYSTOREADDITIONNOTALLOWED,
	SECONDARYSTOREADDITIONNOTALLOWEDGACSHYBRID,
	HTTPSTORENOTALLOWED = 300, //Above HTTPSTORENOTALLOWEDERROR are the codes which we get from native
	ENDPOINTFETCHFAILURE,
	ROAMINGACCOUNTSPARSINGFAILED,
}

export class AccountConfigError extends Error {
	public errorCode: number;
	public payload: ResultJSON;

	constructor(errorCode: number, errorMsg: string, payload?: ResultJSON) {
		super();
		this.errorCode = errorCode;
		this.message = errorMsg;
		if (!!payload) {
			this.payload = payload;
		}
	}
}

export const getErrorObject = (
	code: number,
	errorMsg: string,
	payload: ResultJSON
): HttpRequestError | AccountConfigError => {
	if (code >= HttpErrorCodes.ERROR_HTTP_FETCH_FAILURE) {
		return new HttpRequestError(code, errorMsg);
	}
	return new AccountConfigError(code, errorMsg, payload);
};

export class OnPremRoamingAccountParserError extends Error {
	constructor(message: string) {
		super(message);
	}
}
